import { render, staticRenderFns } from "./PageBar.vue?vue&type=template&id=3115347d"
import script from "./PageBar.vue?vue&type=script&lang=ts"
export * from "./PageBar.vue?vue&type=script&lang=ts"
import style0 from "./PageBar.vue?vue&type=style&index=0&id=3115347d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VPagination } from 'vuetify/lib/components/VPagination';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VPagination,VSelect,VSpacer,VTextField})
